import request from ".";

/**获取 Matrix 仓库代码 */
function getFbaId(data){
  return request('/product/pro/warehousing/getFbaId', 'post', data)
}

/**计算物流运费 */
function calculateShipPrice(data){
  return request('/product/default/v1/matrix/calculateShipPrice', 'post', data)
}

export default{
  getFbaId, calculateShipPrice
}
